/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoMemberSyncResultDto
 */
export interface WebApiIntegrationsDtoMemberSyncResultDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberSyncResultDto
     */
    dataUpdated?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberSyncResultDto
     */
    statusUpdated?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberSyncResultDto
     */
    failed?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebApiIntegrationsDtoMemberSyncResultDto
     */
    errors?: Array<string> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoMemberSyncResultDto interface.
 */
export function instanceOfWebApiIntegrationsDtoMemberSyncResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoMemberSyncResultDtoFromJSON(json: any): WebApiIntegrationsDtoMemberSyncResultDto {
    return WebApiIntegrationsDtoMemberSyncResultDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoMemberSyncResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoMemberSyncResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataUpdated': !exists(json, 'dataUpdated') ? undefined : json['dataUpdated'],
        'statusUpdated': !exists(json, 'statusUpdated') ? undefined : json['statusUpdated'],
        'failed': !exists(json, 'failed') ? undefined : json['failed'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}

export function WebApiIntegrationsDtoMemberSyncResultDtoToJSON(value?: WebApiIntegrationsDtoMemberSyncResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataUpdated': value.dataUpdated,
        'statusUpdated': value.statusUpdated,
        'failed': value.failed,
        'errors': value.errors,
    };
}

